import { useSelector } from 'react-redux';
import PhoneInput from '../../../../../components/forms/PhoneInput';
import { ZorbaInput } from '../../../../../components/forms';
import './index.scss';

export default (props) => {
  const { validationObj } = props;
  const onPhoneNumberChange = (newVal) => {
    props.onChange('phoneNumber', newVal);
  };
  const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);

  return (
    <div className="onboarding-step create">
      <h2>How can we reach you?</h2>
      <div className="phone-note">
        When the seller accepts your offer, our team will contact you
        immediately to ensure you don’t miss the deal.
      </div>
      <PhoneInput
        fullWidth
        label="‎"
        placeholder="Phone number"
        onChange={onPhoneNumberChange}
        errorMessage={validationObj.phoneNumber ? 'Required' : ''}
        showErrorMessage={validationObj.phoneNumber}
      />
      <div style={{ marginTop: '10px' }}>
        <h2>Email</h2>
        <ZorbaInput disabled value={userDetails?.email} />
      </div>
    </div>
  );
};
